import {
    FormattedMessageWithTooltipHeaderRenderer,
    formattedNumberValueGetter,
    gridNumberFormatter,
} from '../../../components';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { CONTEXTUAL_VIDEO_REPORT_ID } from './contextualVideoReportId';

const contextReportColumnDefinition = [
    {
        headerName: FIELDS.CONTEXT.label,
        field: FIELDS.CONTEXT.field,
        label: 'Context',
        type: [leftPinnedColumn],
    },
    {
        headerName: FIELDS.VIEWABILITY_RATE_VS_AVG.label,
        field: FIELDS.VIEWABILITY_RATE_VS_AVG.field,
        cellRenderer: FIELDS.VIEWABILITY_RATE_VS_AVG.cellRenderer,
        headerComponentParams: FIELDS.VIEWABILITY_RATE_VS_AVG.headerComponentParams,
        headerValueGetter: FIELDS.VIEWABILITY_RATE_VS_AVG.headerValueGetter,
    },
    {
        headerName: FIELDS.COMPLETION_RATE_VS_AVG.label,
        field: FIELDS.COMPLETION_RATE_VS_AVG.field,
        cellRenderer: FIELDS.COMPLETION_RATE_VS_AVG.cellRenderer,
        headerComponentParams: FIELDS.COMPLETION_RATE_VS_AVG.headerComponentParams,
        headerValueGetter: FIELDS.COMPLETION_RATE_VS_AVG.headerValueGetter,
    },
    ...[
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.IMPRESSIONS_PCT,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.COMPLETED_VIEWS,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(contextReportColumnDefinition, CONTEXTUAL_VIDEO_REPORT_ID);
